export default __webpack_public_path__ + "static/media/BankPhn.e05d977d.svg";